import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';
import {
  Modal,
  Icon,
  Button,
  Checkbox,
  ToastContainer,
  Toast
} from '@salesforce/design-system-react';
import mcLib from '../../utilities/mc-lib';
import * as Constants from '../../frequency/constants';

import './WelcomeMat.scss';

export class WelcomeMat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toastIsOpen: true
    };
  }

  componentDidMount() {
    this.props.actions.initWelcomeMatStatus(this.props.name);
  }

  componentDidUpdate(prevProps) {
    const currentMat = this.props.welcomeMat[this.props.name];
    const previousMat = prevProps.welcomeMat[this.props.name];
    if (currentMat !== previousMat) {
      if (currentMat.shouldOpen) {
        this.props.actions.openModal(this.props.name);
      }
    }
  }

  handleClose() {
    this.props.actions.closeWelcomeMat(this.props.name);
  }

  handleUpdate() {
    this.props.actions.updateWelcomeMat(
      !this.state.welcomeMatIsOpen,
      this.props.name
    );
  }

  renderToast() {
    const { formatMessage } = this.props.intl;
    const setupLink = (
      <Button
        onClick={() => {
          mcLib.appDeepLink({
            appName: Constants.SETUP_APP,
            link: Constants.ENGAGEMENT_FREQUENCY_LINK
          });
        }}
        variant="link"
        label={formatMessage({ id: 'DeprecationToast.setup.linkText' })}
      />
    );
    const learnMoreLink = (
      <Button
        onClick={() => window.open('https://help.salesforce.com/articleView?id=mc_anb_eef.htm&type=5')}
        variant="link"
        label={formatMessage({ id: 'DeprecationToast.noSetup.linkText' })}
      />
    );
    const toastHeading = this.props.setUpAppIsProvisioned
      ? [
          <FormattedMessage
            id="DeprecationToast.setup.displayText"
            values={{
              setup: <span className="toast-link"> {setupLink} </span>
            }}
          />
        ]
      : [
          <FormattedMessage
            id="DeprecationToast.noSetup.displayText"
            values={{
              learnMore: <span className="toast-link"> {learnMoreLink} </span>
            }}
          />
        ];

    return (
      <ToastContainer>
        <Toast
          labels={{
            heading: toastHeading
          }}
          variant="info"
          onRequestClose={() => {
            this.setState({ toastIsOpen: false });
          }}
        />
      </ToastContainer>
    );
  }

  render() {
    const midHasEefV2Provisioned = this.props.eefV2IsProvisioned;
    const userHasSetupProvisioned = this.props.setUpAppIsProvisioned;
    const { formatMessage } = this.props.intl;
    const currentMat = this.props.welcomeMat[this.props.name];
    const isOpen = currentMat ? currentMat.shouldOpen : false;
    const tiles = [
      {
        icon: 'metrics',
        description: formatMessage({ id: 'WelcomeMat.tiles.metrics' })
      },
      {
        icon: 'einstein',
        description: formatMessage({ id: 'WelcomeMat.tiles.einstein' })
      },
      {
        icon: 'email',
        description: formatMessage({ id: 'WelcomeMat.tiles.email' })
      }
    ];
    return (
      <>
        <Modal
          containerClassName="welcome-mat-container"
          isOpen={isOpen}
          onRequestClose={() => this.handleClose()}
          dismissOnClickingOutside={false}
        >
          <div className="slds-modal__content">
            <div
              className={`${
                midHasEefV2Provisioned
                  ? 'slds-welcome-mat slds-welcome-mat_splash'
                  : 'slds-welcome-mat slds-welcome-mat_info-only'
              }`}
            >
              <div className="slds-welcome-mat__content slds-grid">
                <div
                  className={`${
                    midHasEefV2Provisioned
                      ? 'slds-welcome-mat__info slds-size_1-of-1'
                      : 'slds-welcome-mat__info slds-size_1-of-2'
                  }`}
                >
                  <div className="slds-welcome-mat__info-content">
                    {midHasEefV2Provisioned ? (
                      <h2 className="slds-welcome-mat__info-title">
                        <FormattedMessage id="DeprecationModal.heading" />
                      </h2>
                    ) : (
                      <h2 className="slds-welcome-mat__info-title welcome_mat__eef-info-title-small">
                        <FormattedMessage id="WelcomeMat.heading" />
                      </h2>
                    )}
                    <div className="slds-welcome-mat__info-description slds-text-longform">
                      <p>
                        {midHasEefV2Provisioned ? (
                          <FormattedMessage id="DeprecationModal.description" />
                        ) : (
                          <FormattedMessage id="WelcomeMat.description" />
                        )}
                      </p>
                    </div>
                    <div className="slds-welcome-mat__info-actions">
                      {midHasEefV2Provisioned ? (
                        <>
                          {userHasSetupProvisioned ? (
                            <Button
                              key="deprecationModalSetup"
                              variant="neutral"
                              label={formatMessage({
                                id: 'DeprecationModal.getStarted'
                              })}
                              onClick={() =>
                                mcLib.appDeepLink({
                                  appName: Constants.SETUP_APP,
                                  link: Constants.ENGAGEMENT_FREQUENCY_LINK
                                })
                              }
                            />
                          ) : (
                            <Button
                              key="deprecationModalTellMeMore"
                              variant="neutral"
                              label={formatMessage({
                                id: 'DeprecationModal.tellMeMore'
                              })}
                              onClick={() =>
                                window.open(
                                  'https://help.salesforce.com/articleView?id=mc_anb_eef.htm&type=5',
                                  '_blank'
                                )
                              }
                            />
                          )}
                          <div className="button-divider" />
                          <Button
                            key="deprecationModalContinue"
                            variant="brand"
                            label={formatMessage({
                              id: 'DeprecationModal.continue'
                            })}
                            onClick={() => this.handleClose()}
                          />
                        </>
                      ) : (
                        <Button
                          key="welcomeMatSave"
                          variant="brand"
                          label={formatMessage({ id: 'WelcomeMat.getStarted' })}
                          onClick={() => this.handleClose()}
                        />
                      )}
                      <div className="slds-m-top_large">
                        <div className="slds-form-element">
                          <div className="slds-form-element__control">
                            <div className="slds-checkbox">
                              <Checkbox
                                assistiveText={{
                                  label: formatMessage({
                                    id: 'DeprecationModal.dontShow'
                                  })
                                }}
                                id="dont-show"
                                labels={{
                                  label: formatMessage({
                                    id: 'DeprecationModal.dontShow'
                                  })
                                }}
                                onChange={() => this.handleUpdate()}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {!midHasEefV2Provisioned && (
                  <ul className="slds-welcome-mat__tiles slds-size_1-of-2 slds-welcome-mat__tiles_info-only">
                    {tiles.map(tile => {
                      return (
                        <li
                          key={tile.icon}
                          className="slds-welcome-mat__tile slds-welcome-mat__tile_info-only"
                        >
                          <div className="slds-media">
                            <div className="slds-media__figure slds-media__figure_fixed-width slds-align_absolute-center">
                              <div className="slds-welcome-mat__tile-figure">
                                <div className="slds-welcome-mat__tile-icon-container">
                                  <Icon category="utility" name={tile.icon} />
                                </div>
                              </div>
                            </div>
                            <div className="slds-media__body">
                              <div className="slds-welcome-mat__tile-body">
                                <p className="slds-welcome-mat__tile-description">
                                  {tile.description}
                                </p>
                              </div>
                            </div>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </div>
            </div>
          </div>
        </Modal>
        {midHasEefV2Provisioned && !isOpen && this.state.toastIsOpen
          ? this.renderToast()
          : null}
      </>
    );
  }
}

WelcomeMat.propTypes = {
  welcomeMat: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  name: PropTypes.string,
  modals: PropTypes.object,
  actions: PropTypes.object,
  intl: intlShape.isRequired,
  eefV2IsProvisioned: PropTypes.bool,
  setUpAppIsProvisioned: PropTypes.bool
};

export default injectIntl(WelcomeMat);
